class TatvamasiGiftWrap {

    constructor() {

        this.checkbox = document.getElementById("gift-wrap-checkbox");
        this.wrapper = document.getElementById("gift-message-wrapper");
        this.message = document.getElementById("gift-message");
        this.counter = document.getElementById("gift-count");
        this.rudrakshCheckbox = document.getElementById("rudraksh-checkbox");

        this.init();

    }

    init() {

        if (!this.checkbox) return;

        // Show/Hide gift message + Save Gift Wrap
        this.checkbox.addEventListener("change", async () => {

            this.wrapper.classList.toggle("show", this.checkbox.checked);

            await this.saveAttributes();

        });

        // Character counter + Save Gift Message
        let saveTimer;

this.message.addEventListener("input", () => {

    this.counter.textContent = 250 - this.message.value.length;

    clearTimeout(saveTimer);

    saveTimer = setTimeout(() => {
        this.saveAttributes();
    }, 500);

});

        this.rudrakshCheckbox?.addEventListener("change", async () => {

    await this.saveAttributes();

});

    }

    async saveAttributes() {

        try {

            await fetch("/cart/update.js", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({

                    attributes: {

                        "Gift Wrap": this.checkbox.checked ? "Yes" : "No",

                        "Gift Message": this.message.value,

                        "5 Mukhi Rudraksh": this.rudrakshCheckbox?.checked ? "Yes" : "No"

                    }

                })

            });

        } catch (e) {

            console.error("Gift Attribute Error", e);

        }

    }

}

document.addEventListener("DOMContentLoaded", () => {

    new TatvamasiGiftWrap();

});